import { Menu, PanelLeftClose, PanelLeftOpen } from 'lucide-react'

import { ThemeToggle } from '@/components/layout/ThemeToggle'
import { UserMenu } from '@/components/layout/UserMenu'
import { Button } from '@/components/ui/button'
import { useUiStore } from '@/stores/ui.store'

export function Topbar({ onOpenMobileNav }: { onOpenMobileNav: () => void }) {
  const collapsed = useUiStore((state) => state.sidebarCollapsed)
  const toggleSidebar = useUiStore((state) => state.toggleSidebar)

  return (
    <header className="bg-background/80 border-border sticky top-0 z-30 flex h-14 items-center gap-2 border-b px-4 backdrop-blur">
      <Button variant="ghost" size="icon" className="md:hidden" onClick={onOpenMobileNav}>
        <Menu className="size-4" aria-hidden />
        <span className="sr-only">Open navigation</span>
      </Button>

      <Button variant="ghost" size="icon" className="hidden md:inline-flex" onClick={toggleSidebar}>
        {collapsed ? (
          <PanelLeftOpen className="size-4" aria-hidden />
        ) : (
          <PanelLeftClose className="size-4" aria-hidden />
        )}
        <span className="sr-only">{collapsed ? 'Expand sidebar' : 'Collapse sidebar'}</span>
      </Button>

      <div className="ml-auto flex items-center gap-1">
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  )
}
